import { connect } from 'react-redux';

import UserAlertsContainer from './UserAlertsContainer';
import type { Dispatch } from 'redux';

import type { UUID, Vehicle } from '@cobliteam/common-types';

import {
  type Driver,
  isWebDataSuccess,
  type WebData,
} from '@cobliteam/api-lib';

import {
  type AppState,
  loadDriversRequest,
  loadVehiclesRequest,
  selectDriversById,
  selectVehiclesById,
} from '@cobliteam/store';

type OwnProps = {};

interface DispatchProps {
  loadPageContent: () => void;
}

interface StateProps {
  driversById: Map<UUID, Driver>;
  vehiclesById: Map<UUID, Vehicle>;
}

const valueOrEmpty = <T, U>(webData: WebData<Map<T, U>>): Map<T, U> =>
  isWebDataSuccess(webData) ? webData.data : new Map();

const mapStateToProps = (state: AppState): StateProps => ({
  driversById: valueOrEmpty(selectDriversById(state)),
  vehiclesById: valueOrEmpty(selectVehiclesById(state)),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  loadPageContent: () => {
    dispatch(loadDriversRequest());
    dispatch(loadVehiclesRequest());
  },
});

const UserAlertsDashboardContainer = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  AppState
>(
  mapStateToProps,

  mapDispatchToProps
)(UserAlertsContainer);

export default UserAlertsDashboardContainer;
